import { Component, OnInit, OnDestroy } from '@angular/core';
//import { AllModules, GridOptions, ColDef } from '@ag-grid-enterprise/all-modules';
import { GridOptions, ColDef, GridApi } from "ag-grid-community";
import { SubHeader } from '../../../../core/models/sub-header.model';
import { Subscription } from 'rxjs';
import { GridFormatterService } from '../../../../common/services/grid-formatter.service';
import { AdminReportsService } from '../../../services/admin-reports.service';
import { Router } from '@angular/router';
import { SubHeaderService } from '../../../../core/services/sub-header.service';
import { tap } from 'rxjs/operators';
import { RbdmsOwnersModel } from '../../../models/admin-reports.model';
 

@Component({
    selector: 'app-active-owners-report',
    templateUrl: './active-owners-report.component.html',
    styleUrls: ['./active-owners-report.component.scss'],
    standalone: false
})
export class ActiveOwnersReportComponent implements OnInit, OnDestroy {

    activeRbdmsOwners: RbdmsOwnersModel[]
    gridOptions: GridOptions;
	gridApi?: GridApi;
    subHeader: SubHeader = new SubHeader({
        title: "Active RBDMS Owners",
        buttons: []
    });

    subscription: Subscription = new Subscription();
 
    constructor(        
        private readonly formatService: GridFormatterService,
        private readonly faService: AdminReportsService,
        public router: Router,
        public subHeaderService: SubHeaderService
	) {  }

    ngOnInit() {
        this.subHeaderService.updateSubHeader(this.subHeader);
        let coldefs = this.createColumnDefinitions();
        this.gridOptions = this.formatService.BuildDefaultGridOptionsWithColumns(coldefs, false, true, true, true);;
		this.gridOptions.onGridReady = (params) => { 
            this.gridApi = params.api; 
            this.onGridReady(params);
        };
        this.generateActiveRbdmsOwnersList();
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

    generateActiveRbdmsOwnersList() {
        if (this.gridApi) {
            this.gridApi.setGridOption("loading", true);
        }

        this.subscription = this.faService.getRbdmsOwners().pipe(
            tap((data) => {
                this.activeRbdmsOwners = data;
            })).subscribe({
                next: (success) => {                
                    if (this.gridApi != null) {
                        this.gridApi.setGridOption("rowData", this.activeRbdmsOwners);
                        this.gridApi.setGridOption("loading", false);
                        this.gridApi.sizeColumnsToFit();
                    }
                }, 
                error: (fail) => {
                    console.error(fail);
                    if (this.gridApi != null) {
                        this.gridApi.setGridOption("loading", false);
                    }
                }
            });

    };

    downloadReport() {

        const params = {
            skipHeader: false,
            allColumns: true,
            fileName: `ActiveRBDMSOwners`,
            sheetName: "Active RBDMS Owners",
            exportMode: "xlsx"
        }

        this.formatService.exportDataToExcel(params.fileName, params.sheetName, this.gridApi);
    }

    public createColumnDefinitions() {
        return [

            {
                headerName: "RBDMS Owner Number",
                headerTooltip: "RBDMS Owner Number",
                field: "legacyOwnerNumber",
                tooltipField: 'legacyOwnerNumber',
                filter: "agTextColumnFilter",
                filterParams: this.formatService.defaultTextFilterParams,
                maxWidth: 200
            },
            {
                headerName: "RBDMS Owner Name",
                headerTooltip: "RBDMS Owner Name",
                field: "ownerName",
                tooltipField: 'ownerName',
                filter: "agTextColumnFilter",
                filterParams: this.formatService.defaultTextFilterParams, 
            },
            {
                headerName: "RICS Owner Number",
                headerTooltip: "RICS Owner Number",
                field: "ownerNumber",
                tooltipField: 'ownerNumber',
                filter: "agTextColumnFilter",
                filterParams: this.formatService.defaultTextFilterParams, 
            }, 
            {
                headerName: "Owner Address",
                headerTooltip: "Owner Address",
                field: "ownerAddress",
                tooltipField: 'ownerAddress',
                filter: "agTextColumnFilter",
                filterParams: this.formatService.defaultTextFilterParams, 
            },
            {
                headerName: "RICS Registered?",
                headerTooltip: "RICS Registered?",
                field: "hasRegistered",
                valueGetter: this.formatService.formatBooleanToYesNo("hasRegistered"),
                tooltipValueGetter: this.formatService.formatBooleanToYesNo("hasRegistered"),
                maxWidth: 150
            }
        ] as ColDef[];
    }

    onGridPageChanged(event: any) {
        if (this.gridApi != null) {
            this.gridApi.sizeColumnsToFit();
        }
    }

    onGridReady(event: any) {
        this.formatService.gridReadySizeToFit(event);
    }
 }